export default {
	penalty: 'عقوبة',
	reward: 'مكافآة',
	'add-penalty': 'إضافة عقوبة',
	'add-reward': 'إضافة مكافأة',

	headers: {
		penaltyType: 'نوع العقوبة',
		rewardType: 'نوع المكافأة',
		executionDate: 'تاريخ التنفيذ',
	},

	'delete-message-penalty': 'هل أنت متأكد أنك تريد حذف هذه العقوبة ؟',
	'delete-message-bonus': 'هل أنت متأكد من أنك تريد حذف هذه المكافآة؟'
};
